export const emptyIfNull = (value) => {
    return value || '';
}